import { render, staticRenderFns } from "./ModalInputBase.vue?vue&type=template&id=fb58650a&scoped=true&"
import script from "./ModalInputBase.vue?vue&type=script&lang=ts&"
export * from "./ModalInputBase.vue?vue&type=script&lang=ts&"
import style0 from "./ModalInputBase.vue?vue&type=style&index=0&id=fb58650a&lang=scss&scoped=true&"
import style1 from "./ModalInputBase.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb58650a",
  null
  
)

export default component.exports